<template>
	<v-card outlined>
		<v-card-text>
			<v-row>

				<template
					v-for = "(item_field, idx_info) of info_fields"
				>
					<v-col
						cols = "12"
						sm = "6"
						md = "3"
					>
						<v-card
							v-if 	= "item_field.type == 'switch'"
							outlined
							class  	= "pa-0"
						>

							<v-switch
								dense
								hide-details
								v-if 		= "item_field.type == 'switch'"
								class   	= "pa-0 my-2 ml-2"
								:label 		= "$ml.get(item_field.text)"
								v-model 	= "info[item_field.key]"
								@click 		= "save(false, item_field.key)"
								:disabled 	= "!show.edit_action"
							></v-switch>

						</v-card>
						<v-text-field
							dense
							outlined
							hide-details
							:type 	  		= "item_field.type"
							v-else-if 		= "['text'].includes(item_field.type)"
							:placeholder 	= "item_field.placeholder"
							v-model   		= "info[item_field.key]"
							:label 	  		= "$ml.get(item_field.text)"
							:suffix 		= "item_field.suffix"

						></v-text-field>

						<v-text-field
							dense
							outlined
							hide-details
							:type 	  		= "item_field.type"
							v-else-if 		= "['number'].includes(item_field.type)"
							:placeholder 	= "item_field.placeholder"
							v-model.number	= "info[item_field.key]"
							:label 	  		= "$ml.get(item_field.text)"
							:suffix 		= "item_field.suffix"
							@change 		= "actions(item_field.action,info[item_field.key])"

						></v-text-field>

					</v-col>
				</template>
				<v-col
					cols = "12"

				>
					<v-data-table
						dense
					    fixed-body
					    fixed-header
						v-show  			 = "false"
						:headers 			 = "header_table"
						:items 				 = "render_list"
						class 				 = "elevation-5"
						:options.sync 		 = "options"
						:server-items-length = "total"
						:footer-props 		 = "{
							showFirstLastPage 	: true,
							itemsPerPageOptions : [15, 30],
							showCurrentPage 	: true,
							itemsPerPageText 	: ''
						}"
						loading-text 		 = "Loading... Please wait"
						:loading 			 = "loading"
					    item-key 			 = "index"
					    :height 			 = "layout_height + 'px'"
					>
					    <!-- rowsPerPageText: [30] -->
					    <template v-slot:item.actions="{ item }" >
							<v-btn
								x-small
								color  = "primary"
								@click = "actions('edit', item)"
							>
								<v-icon
									x-small
									v-text = "'mdi-pencil'"
								></v-icon>
							</v-btn>
							<v-btn
								x-small
								color  = "error"
								@click = "actions('confirm_delete', item)"
								class  = "mx-1"
							>
								<v-icon
									x-small
									v-text = "'mdi-delete'"
								></v-icon>
							</v-btn>
						</template>

					    <template v-slot:top>
						<v-toolbar
							flat
							dense
						>
							<!-- <v-toolbar-title> -->
								<v-text-field
								dense
								outlined
								v-model 	 = "search"
								:label 		 = "$ml.get('search')"
								class 		 = "mx-4 pt-1 "
								append-icon  = "mdi-magnify" hide-details
								@input 		 = "v => { search = v.toUpperCase() }"
								@click 		 = "keyboard_is_active()"
								@keyup.enter = "get_search(search)"

							        ></v-text-field>
							        <input
										dark
								type 	= ""
								name 	= ""
								@input 	= "onInputChange"
										:value 	= "input"
										class 	= "input"
										v-show 	= "false"
							        >

							<v-bottom-sheet
								dark
								inset
								v-model = "sheet"
							>
									    <v-sheet
										height = "300px"
										class  = "pa-1"
									    >
									<SimpleKeyboard
										@onChange 	=	"onChange"
										@onKeyPress = "onKeyPress"
										:input 		= "search"
										:theme 		= "theme"
									/>
									    </v-sheet>
								    </v-bottom-sheet>
							<!-- </v-toolbar-title> -->
							<!-- <v-spacer></v-spacer> -->
							<v-divider
							inset
							vertical
							class 	= "mx-4"
						        ></v-divider>

							<v-spacer></v-spacer>
							<v-dialog
								v-model 	= "dialog"
								max-width 	= "500px"
							>

								<template v-slot:activator="{ on, attrs }">
									<v-btn
										dark
										small
										color 	= "primary"
										class 	= "mx-2"
										v-bind 	= "attrs"
										v-on 	= "on"
										v-text 	= "'New'"
									></v-btn>
								</template>
								<v-card outlined>
									<v-card-title
										class = "primary pa-1 body-2"
									>
										<v-icon
											x-small
											color = "white"
											class = "mx-1"
										>
											mdi-new-box
										</v-icon>
										<span
											v-text = "title"
										></span>
										<v-spacer></v-spacer>
										<v-icon
											small
											color  = "error"
											v-text = "'mdi-close'"
											@click = "dialog = false"
										></v-icon>
									</v-card-title>
									<v-card-text>
										<template
											v-for = "(item_field,  idx_field) of fieds_table"

										>
											<v-text-field
													dense
												outlined
													hide-details
												v-if 	= "item_field.type == 'text' || item_field.type == 'number'"
												:key 	= "idx_field"
													:label 	= "$ml.get(item_field.text)"
													v-model = "info[item_field.key]"
													:type 	= "item_field.type"
													class 	= "mx-2 my-2"
												:placeholder = "item_field.placeholder"
											></v-text-field>

											<v-select
												dense
												outlined
												hide-details
												v-else-if 	= "item_field.type == 'select'"
												:label		= "$ml.get(item_field.text)"
												v-model 	= "info[item_field.key]"
												:items 		= "item_field.list"
												class 		= "mx-2 my-2"
											></v-select>
										</template>
									</v-card-text>
									<v-divider></v-divider>
									<v-card-actions>
										<v-spacer></v-spacer>
										<v-btn
											x-small
											color  = "primary"
											v-text = "$ml.get('save')"
											@click = "actions('add')"
										></v-btn>
										<v-btn
											x-small
											color  = "error"
											v-text ="$ml.get('close')"
											@click = "dialog = false"
										></v-btn>
									</v-card-actions>
								</v-card>
							</v-dialog>
						</v-toolbar>

					    </template>

					</v-data-table>
				</v-col>

				<!-- Actions add peripherals -->
				<v-col
					cols = "12"
				>
					<v-card
						outlined
						class = "action-card-list elevation-5 pa-3"
					>
						<v-toolbar
							flat
							dense
							class = "pa-0 mb-3"
						>
							<v-text-field
								dense
								outlined
								v-model 	 = "search_dev"
								:label 		 = "$ml.get('search')"
								class 		 = "mr-4 pt-1"
								append-icon  = "mdi-magnify"
								hide-details
								@click 		 = "keyboard_is_active()"
							></v-text-field>
							<input
								dark
								type 	= ""
								name 	= ""
								@input 	= "onInputChange"
								:value 	= "input"
								class 	= "input"
								v-show 	= "false"
							>

							<v-bottom-sheet
								dark
								inset
								v-model = "sheet"
							>
								<v-sheet
									height = "300px"
									class  = "pa-1"
								>
									<SimpleKeyboard
										@onChange 	= "onChange"
										@onKeyPress = "onKeyPress"
										:input 		= "search_dev"
										:theme 		= "theme"
									/>
								</v-sheet>
							</v-bottom-sheet>

							<v-spacer></v-spacer>
							<v-btn
								dark
								small
								color 	= "primary"
								@click  = "actions('new_action')"
								v-show 	= "show.add_action"
							>
								<v-icon left small>mdi-plus</v-icon>
								{{ $ml.get('new') }}
							</v-btn>
						</v-toolbar>

						<v-alert
							v-if = "!filtered_action_cards.length"
							dense
							outlined
							type = "info"
							class = "mb-0"
						>
							{{ $ml.get('action_device_empty_actions') }}
						</v-alert>

						<v-row v-else dense>
							<v-col
								v-for = "(item, index) of filtered_action_cards"
								:key = "(item.id || item.deviceId || item.name || 'action') + '_' + index"
								cols = "12"
								sm = "10"
								md = "6"
								lg = "3"
							>
								<v-card outlined class = "action-card fill-height">
									<v-card-text class = "pb-2">
										<div class = "d-flex align-start">
											<v-avatar size = "36" color = "primary" class = "mr-3">
												<v-icon small color = "white">{{ action_card_icon(item) }}</v-icon>
											</v-avatar>
											<div class = "flex-grow-1">
												<div class = "subtitle-1 font-weight-bold white--text">{{ action_card_title(item) }}</div>
												<div class = "body-2 grey--text text--lighten-1 mt-1">{{ action_card_sentence(item) }}</div>
											</div>
											<v-btn-toggle mandatory dense class = "ml-2">
												<v-btn
													x-small
													color  = "primary"
													@click = "actions('edit_dev', item, render_list_dev.indexOf(item))"
													v-show = "show.edit_action"
												>
													<v-icon x-small>mdi-pencil</v-icon>
												</v-btn>
												<v-btn
													x-small
													color  = "error"
													@click = "actions('confirm_delete_dev', item, render_list_dev.indexOf(item))"
													v-show = "show.delete_action"
												>
													<v-icon x-small>mdi-delete</v-icon>
												</v-btn>
											</v-btn-toggle>
										</div>

										<v-chip-group column class = "mt-3">
											<v-chip small outlined color = "primary">{{ action_card_type_label(item) }}</v-chip>
											<v-chip small outlined color = "success">{{ action_card_condition_label(item) }}</v-chip>
											<v-chip v-if = "item.name" small outlined>{{ item.name }}</v-chip>
										</v-chip-group>

										<v-expansion-panels flat accordion class = "mt-2">
											<v-expansion-panel>
												<v-expansion-panel-header class = "px-0 caption">
													{{ $ml.get('action_device_details_toggle') }}
												</v-expansion-panel-header>
												<v-expansion-panel-content class = "px-0">
													<v-simple-table dense>
														<tbody>
															<tr
																v-for = "detail of action_card_details(item)"
																:key = "detail.label"
															>
																<td class = "caption grey--text text--lighten-1">{{ detail.label }}</td>
																<td class = "caption">{{ detail.value }}</td>
															</tr>
														</tbody>
													</v-simple-table>
												</v-expansion-panel-content>
											</v-expansion-panel>
										</v-expansion-panels>
									</v-card-text>
								</v-card>
							</v-col>
						</v-row>

						<v-dialog
							v-model 	= "dialog_dev"
							max-width 	= "500px"
						>
<v-card outlined>
									<v-card-title
										class = "primary pa-1 body-2"
									>
										<v-icon
											x-small
											color = "white"
											class = "mx-1"
										>
											mdi-new-box
										</v-icon>
										<span
											v-text = "title_dev"
										></span>
										<v-spacer></v-spacer>
										<v-btn
										        x-small
										        icon
										        class  = "error"
										        @click = "actions('close_dev')"

										    >
											<v-icon
												x-small
												color  = "white"
												v-text = "'mdi-close'"

											></v-icon>
										</v-btn>
									</v-card-title>
									<v-card-subtitle class = "pt-3 pb-0">
										{{ $ml.get('action_device_assistant_intro') }}
									</v-card-subtitle>
									<v-card-text class = "pt-3">
										<v-chip-group column class = "mb-3">
											<v-chip
												v-for = "(step, index) of action_form_visible_steps()"
												:key = "step.key + '_progress'"
												small
												:color = "index == action_form_step_index ? 'primary' : ''"
												:outlined = "index != action_form_step_index"
												@click = "action_form_go_to_step(index)"
											>
												{{ step.number }}. {{ $ml.get(step.title) }}
											</v-chip>
										</v-chip-group>

										<v-card
											v-if = "action_form_current_step()"
											:key = "action_form_current_step().key"
											outlined
											class = "mb-3 action-assistant-step"
										>
											<v-card-title class = "py-2 d-flex align-start flex-nowrap">
												<v-avatar size = "28" color = "primary" class = "mr-4 flex-shrink-0">
													<span class = "caption white--text font-weight-bold">{{ action_form_current_step().number }}</span>
												</v-avatar>
												<div class = "action-step-heading">
													<div class = "subtitle-2 font-weight-bold">{{ $ml.get(action_form_current_step().title) }}</div>
													<div class = "caption grey--text text--lighten-1 mt-1">{{ $ml.get(action_form_current_step().help) }}</div>
												</div>
											</v-card-title>
											<v-card-text class = "pt-0">
												<template
													v-for = "(item_field_dev, idx_field_dev) of action_form_step_fields(action_form_current_step().key)"
												>
													<div
														:key = "action_form_current_step().key + '_' + item_field_dev.key + '_field'"
														class = "mb-3"
													>
														<v-select
															dense
															outlined
															hide-details
															v-if = "is_relay_state_field(item_field_dev)"
															:label = "$ml.get(action_field_label_key(item_field_dev))"
															v-model = "info_dev[item_field_dev.key]"
															:items = "list_relay_states"
															item-text = "text"
															item-value = "key"
														></v-select>

														<v-text-field
															dense
															outlined
															hide-details
															v-else-if = "item_field_dev.type == 'text' || item_field_dev.type == 'number'"
															:label = "$ml.get(action_field_label_key(item_field_dev))"
															v-model = "info_dev[item_field_dev.key]"
															:type = "item_field_dev.type"
															:placeholder = "action_field_placeholder(item_field_dev)"
															:disabled = "item_field_dev && item_field_dev.disabled"
														></v-text-field>

														<v-select
															dense
															outlined
															clearable
															hide-details
															v-else-if = "item_field_dev.type == 'select'"
															:label = "$ml.get(action_field_label_key(item_field_dev))"
															v-model = "info_dev[item_field_dev.key]"
															:items = "render_lists(item_field_dev.list)"
															@change = "render_shows(item_field_dev.key)"
															:value = "item_field_dev.defaultValue"
															:item-value = "item_field_dev.value_item"
															:item-text  = "item_field_dev.key_item"
															:return-object = "item_field_dev.return_obj"
														>
															<template v-if="item_field_dev.key == 'speakerSound'" v-slot:item="{ item, on, attrs }">
																<v-list-item
																	v-bind="attrs"
																	v-on="on"
																	@mouseenter="preview_alarm_sound(item_field_dev, item)"
																>
																	<v-list-item-content>
																		<v-list-item-title>{{ select_item_text(item_field_dev, item) }}</v-list-item-title>
																	</v-list-item-content>
																</v-list-item>
															</template>
														</v-select>

														<v-card
															v-else-if = "item_field_dev.type == 'slide'"
															outlined
															class = "pa-0 caption pb-0"
															height = "40"
														>
															<v-slider
																dense
																:label = "$ml.get('volumen')"
																v-model = "info_dev[item_field_dev.key]"
																max = "100"
																min = "0"
																:prepend-icon = " info_dev[item_field_dev.key] > 80 ? 'mdi-volume-high' : 80  >= info_dev[item_field_dev.key]  && info_dev[item_field_dev.key] >= 30 ? 'mdi-volume-medium' : 'mdi-volume-low'"
																:thumb-size = "24"
																thumb-label = "always"
															></v-slider>
														</v-card>

														<v-card
															v-else-if = "item_field_dev.type == 'switch'"
															outlined
															class = "pa-0 caption pb-0"
															height = "40"
														>
															<v-switch
																dense
																hide-details
																class = "mt-1 ml-1"
																v-model = "info_dev[item_field_dev.key]"
																:label = "$ml.get(action_field_label_key(item_field_dev))"
																:prepend-icon = "item_field_dev.icon"
																:true-value = "item_field_dev.value"
															></v-switch>
														</v-card>

														<v-file-input
															dense
															outlined
															hide-details
															v-else-if = "item_field_dev.type == 'file'"
															:label = "$ml.get(action_field_label_key(item_field_dev))"
															v-model = "info_dev[item_field_dev.key]"
															:loading = "loading_alarm_sound_upload"
															@change = "upload_alarm_sound"
														></v-file-input>

														<div
															v-if = "action_field_help_key(item_field_dev)"
															class = "caption grey--text text--lighten-1 mt-1"
														>
															<v-icon x-small class = "mr-1">mdi-help-circle-outline</v-icon>
															{{ $ml.get(action_field_help_key(item_field_dev)) }}
														</div>

														<v-card
															v-if = "item_field_dev.key == 'speakerSoundFile'"
															outlined
															:class = "['mt-2 pa-3 caption text-center', { 'primary--text': alarm_sound_drag_active, 'primary lighten-5': alarm_sound_drag_active }]"
															style = "border-style: dashed"
															@dragenter.prevent = "set_alarm_sound_drag_active(true)"
															@dragover.prevent = "set_alarm_sound_drag_active(true)"
															@dragleave.prevent = "set_alarm_sound_drag_active(false)"
															@drop.prevent = "drop_alarm_sound"
														>
															{{ $ml.get('drag_drop_audio') }}
														</v-card>
													</div>
												</template>
											</v-card-text>
										</v-card>
										<div class = "d-flex align-center mt-2">
											<v-btn
												small
												outlined
												:disabled = "action_form_step_index <= 0"
												@click = "action_form_previous_step()"
											>
												<v-icon left small>mdi-chevron-left</v-icon>
												{{ $ml.get('previous') }}
											</v-btn>
											<v-spacer></v-spacer>
											<v-btn
												v-if = "!action_form_is_last_step()"
												small
												color = "primary"
												@click = "action_form_next_step()"
											>
												{{ $ml.get('next') }}
												<v-icon right small>mdi-chevron-right</v-icon>
											</v-btn>
										</div>
									</v-card-text>
									<v-divider></v-divider>
									<v-card-actions>
										<v-spacer></v-spacer>
										<v-btn
											v-show = "action_form_is_last_step()"
											x-small
											color  = "primary"
											@click = "actions('save_dev')"
										>
											{{ $ml.get(action_dev) }}
										</v-btn>
										<v-btn
											x-small
											color  = "error"
											v-text = "$ml.get('close')"
											@click = "actions('close_dev')"
										></v-btn>
									</v-card-actions>
								</v-card>

						</v-dialog>
					</v-card>
				</v-col>
			</v-row>
		</v-card-text>

	</v-card>
</template>
<script>
	import EventBus from '@/event-bus'
	import AccessControlService from '@/services/accessControl.service.js'
	import {
		HIKVISION_PLAY_AUDIO_ACTION,
		buildHikvisionPlayAudioValue,
		isEligibleSpeakerTerminal,
		normalizeHikvisionPlayAudioAction,
		normalizeSpeakerSoundPayload,
		parseHikvisionPlayAudioValue,
	} from '@/helpers/js/hikvisionSpeakerAction.js'

	const ACCESS_CONTROL_ACTION_TYPE = 'access_control';

	export default{
		name: 'alarm_actions',
		props:['info_to_component'],
		data: (vm) => ({
			info 	 	: {
				ismodal 		: true,
				isnotificable 	: true,
				issendtows 		: true,
				issendemail 	: true,
				issound 		: true,
				timeout 		: 5,

			},
			info_fields : [
				{
					text : "popup",
					key  : "ismodal",
					type : "switch",

				},
				{
					text : "notifiable",
					key  : "isnotificable",
					type : "switch",

				},
				{
					text : "send_ws",
					key  : "issendtows",
					type : "switch",

				},
				{
					text : "send_email",
					key  : "issendemail",
					type : "switch",

				},
				{
					text : "sound",
					key  : "issound",
					type : "switch",

				},
				{
					text : "alert_time",
					key  : "timeout",
					type : "number",
					suffix : "seg",
					action : "changed_timeout",
				},
				{
					text : "alert",
					key  : "isalert",
					type : "switch",

				},
				{
					text : "require_confirmation",
					key  : "manual_confirmation",
					type : "switch",
				},
			],
			info_id  	 : null,
			title 		 : 'new',
			header_table : [
				{ text: vm.$ml.get('name'), value: 'name' },
				{ text: 'Tag', value: 'tag' },
				{ text: 'Active', value: 'active' },
				// { text: vm.$ml.get('actions'), value: 'actions' },
			],
			fieds_table  : [
				{
					text : 'name',
					key  : "name",
					type : "text",
				},
				{
					text : "tag",
					key  : "tag",
					type : "select",
					list : [
						'person',
						'gun',
						'lpr',
						'objects',
						'motion',
						'anomalies'
					]
				},

				{
					text : "terms",
					placeholder: "Select number to activate alarm",
					key  : "terms",
					type : "number",
				}
			],
			options 		:{ itemsPerPage: 30},
			total 			: 1,
			layout_height 	: 200,
			list 			: [],
			loading 		: false,
			search 			: null,
			input 			: '',
			theme 			: 'hg-theme-default myTheme1', // myTheme1
			sheet 			: false,
			is_open_modal 	: false,
			dialog 			: false,

			title_dev 		 : vm.$ml.get("new"),
			info_dev 		 : { },
			item_dev 		 : null,
			header_table_dev : [
				{ text: 'device', value: 'name' },
				{ text: 'description', value: 'description' },
				{ text: 'type', value: 'type' },
				{ text: 'action', value: 'action' },
				{ text: 'destiny', value: 'destiny' },
				{ text: 'activeOn', value: 'activeOn' },
				{ text: 'smart_event', value: 'smart_event' },
				// { text: vm.$ml.get('manual_confirmation'), value: 'manual_confirmation' },
				{ text: 'delay', value: 'delay' },
				{ text: 'seconds', value: 'seconds' },
				{ text: 'pin', value: 'pin' },
				{ text: 'value', value: 'value' },
				{ text: 'url', value: 'endpoint' },
				{ text: 'options', value: 'options' },
			],
			options_dev 	 : { itemsPerPage : 30 },
			total_dev 		 : 0,
			loading_dev 	 : false,
			search_dev 		 : "",
			dialog_dev 		 : false,
			fieds_table_dev  : [
				{
					key  : "description",
					text : "description",
					placeholder: "action_device_description_placeholder",
					type : "text",
					show : true,
				},
				{
					key  : "type",
					text : "type_device",
					placeholder: "",
					type : "select",
					list : "listTypeAction",
					key_item 	: "text",
					value_item  : "key",
					show : true,
					// return_obj 	: true,
				},
				{
					text : 'device',
					key  : "deviceId",
					type : "select",
					list : "renderDevices",
					show : true,
					key_item 	: "name",
					value_item  : "deviceId",
					return_obj 	: true,
				},
				// {
				// 	text : "type",
				// 	key  : "type",
				// 	type : "text",
				// 	disabled : true,
				// 	show : true,
					// list : "list_type_dev",
				//},

				/*{
					text : "manual_confirmation",
					placeholder: "",
					key  : "manual_confirmation",
					type : "switch",
					show : true,
				},*/
				{
					key  : "action",
					text : "action",
					placeholder: "",
					type : "select",
					list : "list_action_dev",
					key_item 	: "text",
					value_item  : "key",
					show : true,
					return_obj 	: false,

				},
				{
					text 		: "destiny",
					key  		: "destiny",
					type 		: "select",
					list 		: "list_destinys",
					key_item 	: "text",
					value_item  : "key",
					show 		: false,
					return_obj 	: false,
				},
				{
					text 		: "sound",
					key  		: "speakerSound",
					type 		: "select",
					list 		: "list_alarm_sounds",
					key_item 	: "name",
					value_item  : "soundId",
					show 		: false,
					return_obj 	: true,
				},
				{
					text 		: "select_file",
					key  		: "speakerSoundFile",
					type 		: "file",
					show 		: false,
				},
				{
					text : "delay",
					key  : "delay",
					type : "number",
					show : false,
				},
				{
					text : "seconds",
					key  : "seconds",
					type : "number",
					show : false,
				},
				{
					text : "pin",
					key  : "pin",
					type : "number",
					show : false,
				},
				{
					text : "value",
					key  : "value",
					type : "text",
					show : false,
				},
				{
					text : "url",
					key  : "endpoint",
					type : "text",
					show : false,
				},
				{
					text : "frequency",
					key  : "frequency",
					type : "number",
					show : true,
				},
				{
					text 		: "actionsRing",
					key  		: "actionRing",
					type 		: "select",
					list 		: "listActionsRing",
					key_item 	: "text",
					value_item  : "key",
					show 		: false,
					isMultiple 	: true,
				},
				{
					text 		: "file",
					key  		: "file",
					type 		: "select",
					list 		: "listFilesRing",
					key_item 	: "text",
					value_item  : "key",
					show 		: false,
					isMultiple 	: true,
				},
				{
					text 		: "mode",
					key  		: "mode",
					type 		: "select",
					list 		: "listModeRing",
					key_item 	: "text",
					value_item  : "key",
					show 		: false,
					isMultiple 	: true,
				},
				{
					text : "count",
					key  : "count",
					type : "number",
					show : false,
				},
				{
					text : "volumen",
					key  : "volumen",
					type : "slide",
					min : 0,
					max : 100,
					show : false,
				},
				{
					text 		: "smart_event",
					key  		: "smart_event",
					type 		: "select",
					list 		: "renderListSmartEvent",
					key_item 	: "name",
					value_item  : "id",
					show 		: false,
					isMultiple 	: true,
				},
				{
					text 		: "activeOn",
					key  		: "activeOn",
					type 		: "select",
					list 		: "list_activeOn",
					key_item 	: "text",
					value_item  : "key",
					defaultValue 	: "successfully",
					show 		: false,
					return_obj 	: false,
				},
			],
			list_action_dev 	: [ ],
			list_action_dev_opt : {
				device 		: ["snapshot", "record", "webhook"], // IP_CAM
				peripheral 	: ["blink" , "send_value","sera4", "webhook", "ring"], // PERIPHERAL
				access_control : [HIKVISION_PLAY_AUDIO_ACTION],
				system : ["change_smart_event_status", "connect","start_counter","end_counter"]

			},
			show 				: {
				add_action  	: true,
				edit_action 	: true,
				delete_action 	: true,
				description 	: true,
				smart_event		: false,
			},
			action_dev 	 		: 'save',
			item_info   		: null,
			action_info 		: "",
			ID_notification 	: 'alarms_table_action',
			bus 				: {},
			list_dev 			: [],
			// disableds 		: {},
			head_options_dev 	: [
				/*{
					key 	: "manual_confirmation",
					action  : "change_value_table",

				}*/
			],
			list_destinys  		: [
				{
					text 	: vm.$ml.get("final_client"),
					key 	: "final_client",
				},
				{
					text 	: vm.$ml.get("monitor"),
					key 	: "monitor",
				}
			],

			defaultValueRing : {
				action : "",
				file : "",
				mode : "",
				count : 0,
				volumen: 0,
			},
			listActionsRing : [
				{ key : 'start', text : vm.$ml.get("start") },
				{ key: 'stop', text : vm.$ml.get("stop")}
			],
			listFilesRing :[
				{ key: 'userfile1', text : "userfile1" },
				{ key: 'userfile2', text : "userfile2" },
				{ key: 'userfile3', text : "userfile3" },
				{ key: 'userfile4', text : "userfile4" },
				{ key: 'userfile5', text : "userfile5" },
				{ key: 'userfile6', text : "userfile6" },
				{ key: 'userfile7', text : "userfile7" },
				{ key: 'userfile8', text : "userfile8" },
				{ key: 'userfile9', text : "userfile9" },
				{ key: 'userfile10', text : "userfile10" },

			],
			listModeRing : [
				{ key: 'once', text : vm.$ml.get("once") },
				{ key: 'multiple', text : vm.$ml.get("multiple") },
				{ key: 'duration', text : vm.$ml.get("duration") }
			],
			listTypeAction : [
				{ key :  "device", text : vm.$ml.get("device")},
				{ key :  ACCESS_CONTROL_ACTION_TYPE, text : vm.$ml.get("access_control")},
				{ key :  "peripheral", text : vm.$ml.get("peripheral")},
				{ key :  "system", text : vm.$ml.get("system")},
			],
			list_activeOn :[
				{ text 	: vm.$ml.get("successfully"), key 	: "successfully",},
				{ text 	: vm.$ml.get("unsuccessfully"), key 	: "unsuccessfully",},
			],
			list_relay_states : [
				{ text: 'ON', key: 1 },
				{ text: 'OFF', key: 0 },
			],
			list_access_control_terminals : [],
			list_alarm_sounds : [],
			action_form_step_index : 0,
			loading_access_control_terminals : false,
			loading_alarm_sounds : false,
			loading_alarm_sound_upload : false,
				alarm_sound_drag_active : false,


		}), // data

		created(){
			let info_local = this.$Helper.get_local("action_alarm");

			// console.log(this.info_to_component, "ACTIONS")
			if (this.info_to_component && this.info_to_component.default && this.info_to_component.default.actions && this.info_to_component.default.actions.id) {

				// console.log(this.info_to_component, "ACTIONS 2")
				this.render_info(this.info_to_component);
				this.render_devices_action();

			}else{
				const { timeout } = this.$Format.get_list("PARAMETERS");
				if (info_local) {
					this.info = {
						ismodal 		: true,
						isnotificable 	: true,
						issendtows 		: true,
						issendemail 	: true,
						issound 		: true,
						isalert  		: false,
						timeout 		: timeout || 5,

					};//info_local;
				}
			}
			this.render_shows_created();
			let modul = this.$store.getters["auth/permission"](this.$route.name || "smart_event", "", "smart_event");
			if (modul) {
				if (!modul.can_add) {
					this.show.add_action = false;
				}
				if (!modul.can_edit) {
					this.show.edit_action = false;
				}
				if (!modul.can_delete) {
					this.show.delete_action = false;
				}
			}
		}, // created

		watch:{
			options: {
				handler(){
					// this.get_list();
				}, deep: true,
			}, // options

			dialog: function(val){
				if (!val) {
					this.info = {};
				}
			}, // dialog

			info_to_component : function(val){
				if (val) {
					this.render_info(val);
				}
			}, // info_to_component

		}, // watch


		computed:{
			render_list: function(){
				return this.list;
			},
				render_list_dev: function(){
					return this.list_dev;
				},
				filtered_action_cards: function(){
					const query = this.search_dev ? String(this.search_dev).toLowerCase().trim() : '';
					const items = Array.isArray(this.render_list_dev) ? this.render_list_dev : [];
					if (!query) return items;
					return items.filter(item => {
						const normalized = this.normalizeActionDevicePayload(item);
						const text = [
							this.action_card_title(normalized),
							this.action_card_sentence(normalized),
							this.action_card_type_label(normalized),
							this.action_card_condition_label(normalized),
							JSON.stringify(normalized),
						].join(' ').toLowerCase();
						return text.includes(query);
					});
				},
				renderDevices(){
				if (this.info_dev && (this.info_dev.type == ACCESS_CONTROL_ACTION_TYPE || this.info_dev.action == HIKVISION_PLAY_AUDIO_ACTION)) {
					return this.list_access_control_terminals;
				}
				let typeTemp = "";
				// Si es system + (start_counter o acciones que empiecen con end_), filtrar solo cámaras (IP_CAM)
				if(this.info_dev && this.info_dev.type == "system" &&
				   (this.info_dev.action == "start_counter" || (this.info_dev.action && this.info_dev.action.startsWith("end_")))){
					typeTemp = "IP_CAM";
				}else if(this.info_dev && this.info_dev.type && this.info_dev.type){
					typeTemp = this.info_dev.type == "peripheral" ? "PERIPHERAL" : "IP_CAM";
				}
				return this.$store.getters["Devices/list"].filter(x => x && x.type == typeTemp )
			},
			renderListSmartEvent(){
				return this.$SmartEvent.getListSmartEvent();
			}

		}, // computed

		methods : {
			actions(act, item, opt){
				if (act == 'add') {
					this.save();
				}
				if (act == 'edit') {

					this.title 	 = 'edit';
					this.info 	 = item;
					this.info_id = this.list.indexOf(this.info);
					this.dialog  = true;
				}
				if (act == 'confirm_delete') {
					EventBus.$emit('notifications_modal', {
						type: act,
						ID: this.ID_notification,
					})
				}
				if (act == 'delete'){
					this.delete();
				}
				if ( act == 'save_dev') {
					if (this.action_dev == 'save') {
						this.save_dev();
					}else{
						this.update_dev();


					}
				}
				if (act == 'edit_dev') {
					this.info_dev 	 = this.normalizeActionDevicePayload({ ...item });
					this.item_info	 = opt;
					this.dialog_dev  = true;
					this.action_dev  = "update";
					this.action_form_step_index = 0;
					if (this.info_dev.action == 'ring') {
						this.info_dev = this.renderToFormatRing(this.info_dev);
					}
					if (this.info_dev.action == 'send_value') {
						this.normalize_relay_state_value();
					}
					if (this.info_dev.action == HIKVISION_PLAY_AUDIO_ACTION) {
						this.info_dev.type = ACCESS_CONTROL_ACTION_TYPE;
						this.apply_hikvision_value_to_info();
						this.ensure_access_control_sound_options();
					}
				if (this.info_dev.type && this.list_action_dev_opt[this.info_dev.type]) {
					this.list_action_dev = this.list_action_dev_opt[this.info_dev.type];
				}else{
					console.warn("No find option select in device ", this.info_dev.type)
				}
					this.render_shows("type", false);
					this.show.action = true;
					this.render_shows('action');
				}

				if (act == "new_action") {
					this.info_dev 	= {};
					this.action_form_step_index = 0;
					this.render_shows("type");
				// this.render_shows('action');
					this.dialog_dev = true;
				}


				if ( act == "confirm_delete_dev") {
					EventBus.$emit('notifications_modal', {
						type: 'confirm_delete',
						ID: this.ID_notification,
					})

					this.info_dev 	 = item;
					this.item_info	 = opt;
					this.action_info = "delete_dev";
				}
				if (act == 'close_dev') {
					// dialog_dev = false
					this.dialog_dev 	= false;
					this.info_dev   	= {};
					this.action_dev  	= "save";
					this.render_shows("type");
				// this.render_shows('action');

				}else
				if( act && act.action == "change_value_table"){
					item[act.key] =  !item[act.key];
				}else if(act == "changed_timeout"){
					this.save(false);
				}
			}, // actions

			renderToFormatRing(item){
				if (item && item.value && typeof item.value == "string" ) {
					const tempRing = this.$Helper.to_object(item.value);
					console.log(" VALUE ", tempRing)
					if (tempRing) {
						let actionRing = tempRing.action;
						delete tempRing.action;
						item = {
							...item,
							actionRing,
							...tempRing
						}
					}
				}
				return item
			},

			render_info(item){
				if (item){
					if (item.default && item.default.actions) {
						this.info = item.default.actions;

					}
				}
			}, // render info

			render_devices_action(){
				if (this.info && this.info.detail_action_device && this.info.detail_action_device.length > 0) {
					this.list_dev  = this.info.detail_action_device.map((dev) => {
						let temp_dev = this.normalizeActionDevicePayload({ ...dev });
						if (temp_dev) {
							let temp = this.$Format.render_device(temp_dev.deviceId);
							if (temp) {
								temp_dev.name = temp.name;
							}else{
								const accessControlTerminal = this.list_access_control_terminals.find(device => device.deviceId == temp_dev.deviceId);
								if (accessControlTerminal && accessControlTerminal.name) {
									temp_dev.name = accessControlTerminal.name;
								} else if (temp_dev.action == HIKVISION_PLAY_AUDIO_ACTION) {
									temp_dev.name = temp_dev.name || temp_dev.deviceId;
								} else {
									temp_dev.name = this.$ml.get("not_found_device");
								}
							}
						}

						return temp_dev;
					});
					this.total_dev = this.list_dev.length;
				}
			}, // render devices action

			normalizeActionDevicePayload(item){
				if (!item) {
					return item;
				}
				let result = { ...item };
				result.action = normalizeHikvisionPlayAudioAction(result.action);
				if (!result.activeon && result.activeOn) {
					result.activeon = result.activeOn;
				}
				if (!result.activeOn && result.activeon) {
					result.activeOn = result.activeon;
				}
				if (!result.activeon && !result.activeOn) {
					result.activeOn = 'successfully';
					result.activeon = 'successfully';
				}
				return result;
			},

			getActionLabel(action){
				const labels = {
					[HIKVISION_PLAY_AUDIO_ACTION]: 'action_device_action_play_audio',
					send_value: 'action_device_action_send_value',
					snapshot: 'action_device_action_snapshot',
					record: 'action_device_action_record',
					webhook: 'action_device_action_webhook',
					blink: 'action_device_action_blink',
					ring: 'action_device_action_ring',
					change_smart_event_status: 'action_device_action_change_smart_event_status',
					connect: 'action_device_action_connect',
					start_counter: 'action_device_action_start_counter',
					end_counter: 'action_device_action_end_counter',
				};
				if (!labels[action]) return action;
				const translated = this.$ml.get(labels[action]);
				if (translated && translated != labels[action]) return translated;
				if (action == HIKVISION_PLAY_AUDIO_ACTION) return this.$ml.get('sound');
				return action;
			},

			action_card_icon(item){
				if (!item) return 'mdi-cog-outline';
				if (item.action == HIKVISION_PLAY_AUDIO_ACTION || item.action == 'ring') return 'mdi-volume-high';
				if (item.action == 'snapshot') return 'mdi-camera';
				if (item.action == 'record') return 'mdi-record-rec';
				if (item.action == 'webhook') return 'mdi-webhook';
				if (item.type == 'system') return 'mdi-cog-outline';
				return 'mdi-flash';
			},

			action_card_title(item){
				if (!item) return this.$ml.get('action_device_default_title');
				return item.description || this.getActionLabel(item.action) || this.$ml.get('action_device_default_title');
			},

			action_card_type_label(item){
				if (!item || !item.type) return this.$ml.get('action_device_type_unknown');
				if (item.type == 'peripheral') return this.$ml.get('action_device_type_peripheral');
				if (item.type == ACCESS_CONTROL_ACTION_TYPE) return this.$ml.get('action_device_type_access_control');
				if (item.type == 'device') return this.$ml.get('action_device_type_device');
				if (item.type == 'system') return this.$ml.get('action_device_type_system');
				return item.type;
			},

			action_card_condition_label(item){
				const activeOn = item && (item.activeOn || item.activeon);
				if (activeOn == 'unsuccessfully') return this.$ml.get('action_device_condition_failure');
				return this.$ml.get('action_device_condition_success');
			},

			action_card_sentence(item){
				if (!item) return '';
				const action = this.getActionLabel(item.action) || 'Ejecutar acción';
				const device = item.name || item.deviceId || this.$ml.get('action_device_selected_device_fallback');
				const value = this.render_action_device_value(item);
				const condition = this.action_card_condition_label(item).toLowerCase();
				if (item.action == HIKVISION_PLAY_AUDIO_ACTION) {
					return this.$ml.get('action_device_sentence_play_audio') + ' ' + (value || this.$ml.get('action_device_sound_fallback')) + ' ' + this.$ml.get('action_device_sentence_on') + ' ' + device + ' ' + condition + '.';
				}
				if (item.action == 'snapshot') return this.$ml.get('action_device_sentence_snapshot') + ' ' + device + ' ' + condition + '.';
				if (item.action == 'record') return this.$ml.get('action_device_sentence_record') + ' ' + device + ' ' + condition + '.';
				if (item.action == 'webhook') return this.$ml.get('action_device_sentence_webhook') + ' ' + condition + '.';
				if (item.action == 'change_smart_event_status') return this.$ml.get('action_device_sentence_smart_event') + ' ' + condition + '.';
				return action + ' ' + this.$ml.get('action_device_sentence_on') + ' ' + device + ' ' + condition + '.';
			},

			action_card_details(item){
				if (!item) return [];
				const details = [
					{ label: this.$ml.get('description'), value: item.description },
					{ label: this.$ml.get('device'), value: item.name || item.deviceId },
					{ label: this.$ml.get('type'), value: this.action_card_type_label(item) },
					{ label: this.$ml.get('action'), value: this.getActionLabel(item.action) },
					{ label: this.$ml.get('action_device_detail_condition'), value: this.action_card_condition_label(item) },
					{ label: this.$ml.get('action_device_detail_sound_value'), value: this.render_action_device_value(item) },
					{ label: this.$ml.get('destiny'), value: item.destiny },
					{ label: this.$ml.get('smart_event'), value: item.smart_event },
					{ label: this.$ml.get('action_device_label_start_wait'), value: item.seconds ? item.seconds + ' ' + this.$ml.get('seconds') : null },
					{ label: this.$ml.get('action_device_label_active_duration'), value: item.delay ? item.delay + ' ' + this.$ml.get('seconds') : null },
					{ label: this.$ml.get('pin'), value: item.pin },
					{ label: this.$ml.get('url'), value: item.endpoint },
					{ label: this.$ml.get('frequency'), value: item.frequency },
				];
				return details.filter(detail => detail.value !== undefined && detail.value !== null && detail.value !== '');
			},

			action_form_steps(){
				return [
					{ key: 'identify', number: 1, title: 'action_device_step_identify_title', help: 'action_device_step_identify_help' },
					{ key: 'target', number: 2, title: 'action_device_step_target_title', help: 'action_device_step_target_help' },
					{ key: 'config', number: 3, title: 'action_device_step_config_title', help: 'action_device_step_config_help' },
					{ key: 'timing', number: 4, title: 'action_device_step_timing_title', help: 'action_device_step_timing_help' },
				];
			},

			action_form_step_keys(step){
				const steps = {
					identify: ['description'],
					target: ['type', 'deviceId', 'action'],
					config: ['destiny', 'speakerSound', 'speakerSoundFile', 'delay', 'seconds', 'pin', 'value', 'frequency', 'actionRing', 'file', 'mode', 'count', 'volumen'],
					timing: ['smart_event', 'activeOn'],
				};
				return steps[step] || [];
			},

			should_show_action_field(field){
				if (!field || field.key == 'endpoint') return false;
				return this.show[field.key] === true;
			},

			action_form_step_fields(step){
				const keys = this.action_form_step_keys(step);
				return this.fieds_table_dev.filter(field => keys.includes(field.key) && this.should_show_action_field(field));
			},

			action_form_visible_steps(){
				return this.action_form_steps().filter(step => this.action_form_step_fields(step.key).length > 0);
			},

			action_form_current_step(){
				const steps = this.action_form_visible_steps();
				if (!steps.length) return null;
				const index = Math.min(Math.max(this.action_form_step_index, 0), steps.length - 1);
				return steps[index];
			},

			action_form_go_to_step(index){
				const steps = this.action_form_visible_steps();
				if (!steps.length) {
					this.action_form_step_index = 0;
					return;
				}
				this.action_form_step_index = Math.min(Math.max(index, 0), steps.length - 1);
			},

			action_form_next_step(){
				this.action_form_go_to_step(this.action_form_step_index + 1);
			},

			action_form_previous_step(){
				this.action_form_go_to_step(this.action_form_step_index - 1);
			},

			action_form_is_last_step(){
				const steps = this.action_form_visible_steps();
				return !steps.length || this.action_form_step_index >= steps.length - 1;
			},

			is_relay_state_field(field){
				return this.info_dev && this.info_dev.action == 'send_value' && field && field.key == 'value';
			},

			normalize_relay_state_value(){
				if (!this.info_dev || this.info_dev.action != 'send_value') return;
				if (this.info_dev.value === '1') this.info_dev.value = 1;
				if (this.info_dev.value === '0') this.info_dev.value = 0;
			},

			action_field_placeholder(field){
				if (!field || !field.placeholder) return '';
				if (field.key == 'description') return this.$ml.get(field.placeholder);
				return field.placeholder;
			},

			action_field_label_key(field){
				if (!field) return '';
				if (this.info_dev && this.info_dev.action == 'send_value') {
					if (field.key == 'pin') return 'action_device_label_relay_channel';
					if (field.key == 'value') return 'action_device_label_relay_state';
					if (field.key == 'seconds') return 'action_device_label_start_wait';
					if (field.key == 'delay') return 'action_device_label_active_duration';
				}
				if (field.key == 'activeOn') return 'action_device_label_when';
				return field.text;
			},

			action_field_help_key(field){
				if (!field) return null;
				if (this.info_dev && this.info_dev.action == 'send_value') {
					if (field.key == 'pin') return 'action_device_help_relay_channel';
					if (field.key == 'value') return 'action_device_help_relay_state';
				}
				const keys = {
					description: 'action_device_help_description',
					type: 'action_device_help_type',
					deviceId: 'action_device_help_device',
					action: 'action_device_help_action',
					destiny: 'action_device_help_destiny',
					speakerSound: 'action_device_help_sound',
					speakerSoundFile: 'action_device_help_sound_file',
					delay: 'action_device_help_delay',
					seconds: 'action_device_help_seconds',
					frequency: 'action_device_help_frequency',
					actionRing: 'action_device_help_ring_action',
					file: 'action_device_help_ring_file',
					mode: 'action_device_help_ring_mode',
					count: 'action_device_help_count',
					volumen: 'action_device_help_volume',
					smart_event: 'action_device_help_smart_event',
					activeOn: 'action_device_help_active_on',
				};
				return keys[field.key] || null;
			},

			select_item_text(field, item){
				if (!item) return '';
				const key = field && field.key_item ? field.key_item : 'text';
				return item[key] || item.text || item.name || item.key || '';
			},

			sound_preview_url(sound){
				if (!sound || !sound.url_path) return '';
				if (sound.url_path.startsWith('http') || sound.url_path.startsWith('blob:')) return sound.url_path;
				if (sound.type == 'local' || sound.url_path.startsWith('/sounds/')) return sound.url_path;
				return this.$URL + sound.url_path;
			},

			preview_alarm_sound(field, sound){
				if (!field || field.key != 'speakerSound' || !sound) return;
				if (this.$Sounds && this.$Sounds.play && sound.name && sound.type == 'local') {
					this.$Sounds.play(sound.name);
					return;
				}
				const url = this.sound_preview_url(sound);
				if (url && this.$Sounds && this.$Sounds.play_new_sound) this.$Sounds.play_new_sound(url);
			},

			render_action_device_value(item){
				if (item && item.action == HIKVISION_PLAY_AUDIO_ACTION) {
					const parsed = parseHikvisionPlayAudioValue(item.value);
					return parsed && parsed.name ? parsed.name : '';
				}
				return item ? item.value : '';
			},

			normalizeSoundRows(rows){
				return (Array.isArray(rows) ? rows : []).map(sound => {
					const normalized = normalizeSpeakerSoundPayload(sound, this.$URL);
					return normalized ? { ...normalized, type: sound.type, source: sound.source } : null;
				}).filter(Boolean);
			},

			extractRows(payload){
				if (Array.isArray(payload)) return payload;
				if (!payload || typeof payload !== 'object') return [];
				if (Array.isArray(payload.rows)) return payload.rows;
				if (Array.isArray(payload.results)) return payload.results;
				if (Array.isArray(payload.data)) return payload.data;
				if (Array.isArray(payload.devices)) return payload.devices;
				if (Array.isArray(payload.items)) return payload.items;
				if (payload.data && typeof payload.data === 'object') return this.extractRows(payload.data);
				return [];
			},

			async load_access_control_terminals(){
				this.loading_access_control_terminals = true;
				try {
					const devices = [];
					let page = 1;
					let hasMore = true;
					const limit = 200;
					while (hasMore) {
						const res = await AccessControlService.listDevices({ page, limit });
						const payload = res && res.data ? res.data : res;
						const rows = this.extractRows(payload);
						devices.push(...rows);
						if (payload && payload.total !== undefined) {
							hasMore = Number(payload.total) > devices.length;
						} else if (payload && payload.pages !== undefined && payload.page !== undefined) {
							hasMore = Number(payload.page) < Number(payload.pages);
						} else {
							hasMore = false;
						}
						page += 1;
					}
					this.list_access_control_terminals = devices;
					this.hydrate_access_control_terminal_selection();
				} catch (er) {
					console.log('Error loading Access Control terminals ', er);
					this.list_access_control_terminals = [];
				} finally {
					this.loading_access_control_terminals = false;
				}
			},

			async load_alarm_sounds(){
				this.loading_alarm_sounds = true;
				try {
					const sounds = [];
					let page = 1;
					let hasMore = true;
					while (hasMore) {
						const res = await this.$axios.get(this.$URL + '/api/v1/sounds/?page=' + page);
						const payload = res && res.data ? res.data : res;
						const rows = this.extractRows(payload);
						sounds.push(...rows);
						const pageInfo = payload && payload.data && typeof payload.data === 'object' && !Array.isArray(payload.data) ? payload.data : payload;
						if (pageInfo && pageInfo.pages !== undefined && pageInfo.page !== undefined) {
							hasMore = Number(pageInfo.page) < Number(pageInfo.pages);
						} else if (pageInfo && pageInfo.count !== undefined) {
							hasMore = Number(pageInfo.count) > sounds.length;
						} else {
							hasMore = false;
						}
						page += 1;
					}
					const registrySounds = this.$Sounds && this.$Sounds.get ? this.$Sounds.get('array', true) : [];
					this.list_alarm_sounds = this.normalizeSoundRows([ ...registrySounds, ...sounds ]);
					this.hydrate_alarm_sound_selection();
				} catch (er) {
					console.log('Error loading sounds for Hikvision speaker action ', er);
					const registrySounds = this.$Sounds && this.$Sounds.get ? this.$Sounds.get('array', true) : [];
					this.list_alarm_sounds = this.normalizeSoundRows(registrySounds);
				} finally {
					this.loading_alarm_sounds = false;
				}
			},

			ensure_access_control_sound_options(){
				if (!this.list_access_control_terminals.length && !this.loading_access_control_terminals) {
					this.load_access_control_terminals();
				} else {
					this.hydrate_access_control_terminal_selection();
				}
				if (!this.list_alarm_sounds.length && !this.loading_alarm_sounds) {
					this.load_alarm_sounds();
				} else {
					this.hydrate_alarm_sound_selection();
				}
			},

			hydrate_access_control_terminal_selection(){
				if (!this.info_dev || this.info_dev.action != HIKVISION_PLAY_AUDIO_ACTION) return;
				const deviceId = this.info_dev.deviceId && this.info_dev.deviceId.deviceId ? this.info_dev.deviceId.deviceId : this.info_dev.deviceId;
				const terminal = this.list_access_control_terminals.find(device => device.deviceId == deviceId);
				if (terminal) this.$set(this.info_dev, 'deviceId', terminal);
			},

			hydrate_alarm_sound_selection(){
				if (!this.info_dev || this.info_dev.action != HIKVISION_PLAY_AUDIO_ACTION || !this.info_dev.speakerSound) return;
				const soundId = this.info_dev.speakerSound.soundId;
				const sound = this.list_alarm_sounds.find(item => item.soundId == soundId);
				if (sound) this.$set(this.info_dev, 'speakerSound', sound);
			},

			apply_hikvision_value_to_info(){
				if (!this.info_dev || this.info_dev.action != HIKVISION_PLAY_AUDIO_ACTION) return;
				const parsed = parseHikvisionPlayAudioValue(this.info_dev.value);
				if (!parsed) return;
				const normalized = normalizeSpeakerSoundPayload(parsed, this.$URL) || parsed;
				this.$set(this.info_dev, 'speakerSound', normalized);
			},

			notify_hikvision_validation(message){
				EventBus.$emit('notifications_modal', {
					type: 'warning',
					message,
				});
			},

			validate_hikvision_payload(){
				if (!this.info_dev || this.info_dev.action != HIKVISION_PLAY_AUDIO_ACTION) return true;

				const selectedDevice = this.info_dev.deviceId;
				const selectedDeviceId = selectedDevice && selectedDevice.deviceId ? selectedDevice.deviceId : selectedDevice;
				if (!selectedDeviceId) {
					this.notify_hikvision_validation(this.$ml.get('req_sel_device'));
					return false;
				}

				if (!normalizeSpeakerSoundPayload(this.info_dev.speakerSound, this.$URL)) {
					this.notify_hikvision_validation(this.$ml.get('sound') + ' ' + this.$ml.get('required'));
					return false;
				}

				return true;
			},

			prepare_hikvision_payload(){
				if (!this.info_dev || this.info_dev.action != HIKVISION_PLAY_AUDIO_ACTION) return;
				this.info_dev.type = 'peripheral';
				this.info_dev.frequency = this.info_dev.frequency || 0;
				this.info_dev.value = buildHikvisionPlayAudioValue(this.info_dev.speakerSound, this.$URL);
				delete this.info_dev.speakerSound;
				delete this.info_dev.speakerSoundFile;
			},

			set_alarm_sound_drag_active(active){
				this.alarm_sound_drag_active = active;
			},

			is_audio_file(file){
				if (!file) return false;
				if (file.type && file.type.startsWith('audio/')) return true;
				return /\.(aac|aiff|flac|m4a|mp3|ogg|opus|wav|weba|wma)$/i.test(file.name || '');
			},

			notify_invalid_alarm_sound_file(){
				this.notify_hikvision_validation(this.$ml.get('invalid_audio_file'));
			},

			drop_alarm_sound(event){
				this.set_alarm_sound_drag_active(false);
				const file = event && event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
				if (file) this.upload_alarm_sound(file);
			},

			async upload_alarm_sound(file){
				if (!file) return;
				if (!this.is_audio_file(file)) {
					this.notify_invalid_alarm_sound_file();
					this.$set(this.info_dev, 'speakerSoundFile', null);
					return;
				}
				this.loading_alarm_sound_upload = true;
				try {
					const formData = new FormData();
					formData.append('file', file, file.name);
					formData.append('name', file.name);
					formData.append('type', file.type);
					const res = await this.$axios.post(this.$URL + '/api/v1/sounds', formData);
					await this.load_alarm_sounds();
					const uploaded = normalizeSpeakerSoundPayload(res && res.data, this.$URL);
					if (uploaded) {
						const selected = this.list_alarm_sounds.find(sound => sound.soundId == uploaded.soundId) || uploaded;
						this.$set(this.info_dev, 'speakerSound', selected);
					}
				} catch (er) {
					console.log('Error uploading Hikvision speaker sound ', er);
				} finally {
					this.loading_alarm_sound_upload = false;
					this.$set(this.info_dev, 'speakerSoundFile', null);
				}
			},

			render_lists(list){
				if (list == 'devices') {
					return this.$store.getters["Devices/list"];
				}else
				if (list == 'list_action_dev') {
					return this.list_action_dev.map(action => ({ key: action, text: this.getActionLabel(action) }));
				}else
				if (this[list]) {
					return this[list];
				}
				return [];
			}, // render lists

			get_list(){
				const { itemsPerPage, page } = this.options;
				let pg = 1,
					sw = 0;

				this.loading = true;

				if ( itemsPerPage == 15 ) {
					if (page % 2 == 0) {
						pg = (page / 2);
						sw = 2;
					}else{
						pg = parseInt(page / 2) + 1;
						sw = 1;
					}
				}else{
					pg = page
				}
				const api = this.$URL + '/api/v1/alarm/?page=' + pg;

				this.$axios.get(api).then( res => {
					console.log(res, 'Get list');
					let items  = res.data.rows;

					this.total = parseInt(res.data.count);

					if (itemsPerPage <= 15) {
						items = items.slice((sw - 1) * itemsPerPage, sw  + itemsPerPage );
					}

					this.list = items;
					this.loading = false;

				}).catch( er => {
					console.log(er, 'Error get list');
					this.loading = false;
					if (er && er.message == 'Network Error') {
						EventBus.$emit('notifications_modal', {
							type 	: 'error',
							message : er.message

						})
					}
					// this.get_local();
				})
			}, // get list

			save(is_local = true, key){
				if (!this.$store.getters["auth/permission"](this.$route.name || "smart_event", "can_edit", "smart_event")) {
					this.$EventBus.$emit("notifications_modal",{
						type 		: "warning",
						message 	: this.$ml.get("no_have_permission_edit") + " : " + this.$ml.get("smart_event")
					});

					return false
				}
					console.log(" Actions ", is_local, this.info)
				if (!is_local){
					let temp_action = { ...this.info };
					this.$Helper.set_local("action_alarm", temp_action);
					// update
					if (this.info && this.info.id) {
						console.log(" Actions 1 update" )

						const api = this.$URL + '/api/v1/alarm/action/' + this.info.id;
						this.$axios.put(api, this.info).then( res => {
							this.$emit('info_component', {
								act 	: 'render_compt',
								opt 	: 'actions',
								value 	: this.info,
							});
							this.$EventBus.$emit("notifications_modal",{
								type 	: 'updated',
								message : this.$ml.get('actions')
							})
						}).catch( er => {
							console.log("Error update action ", er);
						})

					}else{
						this.$emit('info_component', {
							act 	: 'render_compt',
							opt 	: 'actions',
							value 	: this.info,
						})
					}
				}else{

					const info_table = this.info;
					let list_temp  	 = this.list;
					let msg  		 = 'saved';


					/*
					this.$nextTick(()=>{

					if (this.title == 'new') {
						list_temp.push(info_table);
						this.total++;

					}else{
						list_temp[this.info_id] = info_table;
						msg = 'updated'
						this.title = 'new';
					}
					EventBus.$emit('notifications_modal', {
							type: msg,
						})
					this.list = list_temp;
					this.dialog = false;
					})
						*/
					this.info 		= {};
				}

			}, // save

			delete(){
				this.list.splice(this.info_id, 1);
				if (this.info_id == 0) {
					this.list = [];
				}
				EventBus.$emit('notifications_modal',{
					type: 'deleted'
				});
			}, // delete

			onChange(input) {
			this.input  = input;
			this.search = input.toUpperCase();
		    },
		    onKeyPress(button) {
			    if (button=='{enter}') {
				this.get_search(this.search);
			    }
		    },
		    onInputChange(input) {
			this.input = input.target.value;

		    },

			reset_type_device_fields(type){
				const emptyFields = [
					'deviceId',
					'name',
					'action',
					'activeOn',
					'activeon',
					'speakerSound',
					'speakerSoundFile',
					'value',
					'delay',
					'pin',
					'seconds',
					'destiny',
					'endpoint',
					'actionRing',
					'file',
					'mode',
					'count',
					'volumen',
					'smart_event',
				];
				emptyFields.forEach(field => this.$set(this.info_dev, field, null));
				this.$set(this.info_dev, 'type', type);
				this.$set(this.info_dev, 'frequency', 0);
			},

		    keyboard_is_active(){
			let key_board=false;
			if (localStorage.getItem('virtual_Key_board')) {
					key_board=JSON.parse(localStorage.getItem('virtual_Key_board'));
				}

			if (key_board==true) {
				this.sheet=true;

			}

		    },

		    render_shows(key, resetFields = true){
				if( key == "type"){
					this.show.action = false;
					this.show.deviceId = false;
					this.show.type = true;
					this.$set(this.show, 'smart_event', false);
					this.show.activeOn = false;
					this.show.speakerSound = false;
					this.show.speakerSoundFile = false;
					this.show.delay = false;
					this.show.pin = false;
					this.show.value = false;
					this.show.seconds = false;
					this.show.destiny = false;
					this.show.endpoint = false;
					this.show.actionRing = false;
					this.show.file = false;
					this.show.mode = false;
					this.show.count = false;
					this.show.volumen = false;
					let {type} 	= this.info_dev;
					if (resetFields) this.reset_type_device_fields(type);
					if(type == "system"){
						this.show.action  	= true;
						this.info_dev.type = "system";
						this.list_action_dev = this.list_action_dev_opt["system"];
						this.info_dev.action = this.info_dev.action || "change_smart_event_status";
						this.render_shows("action");
					}else if(type == "device"){
						this.list_action_dev = this.list_action_dev_opt["device"];
						this.show.deviceId = true;
					}else if(type == ACCESS_CONTROL_ACTION_TYPE){
						this.list_action_dev = this.list_action_dev_opt[ACCESS_CONTROL_ACTION_TYPE];
						this.show.deviceId = true;
						this.show.frequency = false;
						this.show.frecuency = false;
						this.info_dev.frequency = 0;
						this.ensure_access_control_sound_options();
					}else if(type == "peripheral"){
						this.list_action_dev = this.list_action_dev_opt["peripheral"];
						this.show.deviceId = true;
						//this.show.type = true;
					}

				}else
			if (key == 'action') {
				let type 	= this.info_dev.type;
				let action 	= this.info_dev['action'];
				this.show.delay 	= false;
				this.show.pin 		= false;
				this.show.value 	= false;
				this.show.seconds 	= false;
				this.show.destiny  	= false;
				this.show.endpoint 	= false;
					this.show.actionRing 	= false;
					this.show.file 			= false;
					this.show.mode 			= false;
					this.show.count			= false;
					this.show.volumen 		= false;
					this.show.speakerSound = false;
					this.show.speakerSoundFile = false;
					this.show.frequency = false;
					this.show.activeOn 		= false;

					this.info_dev.activeOn = this.info_dev.activeOn ? this.info_dev.activeOn : "successfully";
				if (type == 'device') {
						this.show.activeOn = true;
					if (action == 'snapshot') {
						this.show.delay 	= true;
							this.show.endpoint = true;


					}else
					if (action == 'record') {
						this.show.delay  = true;
						this.show.seconds = true;
							this.show.endpoint = true;

					}else{
						this.show.delay  	= false;
						this.show.seconds 	= false;
						this.show.pin 		= false;
						this.show.value 	= false;
							this.show.endpoint = true;

					}

					}else if(type == ACCESS_CONTROL_ACTION_TYPE){
						this.show.activeOn = true;
						this.show.deviceId = true;
						this.show.speakerSound = true;
						this.show.speakerSoundFile = true;
						this.show.frequency = false;
						this.show.frecuency = false;
						this.info_dev.frequency = 0;
						this.ensure_access_control_sound_options();
					}else if(type == "peripheral"){
						this.show.activeOn = true;
						this.show.frecuency = true
					if (action == 'blink') {
						this.show.delay = true;
						this.show.pin 	= true;
						this.show.value = false;
							this.show.destiny 	= true;
						this.show.endpoint 	= true;
						this.show.seconds 	= true;


					}else
					if (action == 'send_value') {
						this.show.delay = true;
						this.show.pin 	= true;
						this.show.value = true;
							this.show.destiny 	= true;
						this.show.endpoint 	= true;
						this.show.seconds 	= true;
					}else
					if (action == 'ring') {
						this.show.destiny 		= true;
						this.show.endpoint 		= false;
						this.show.actionRing 	= true;
							this.show.file 			= true;
							this.show.mode 			= true;
							this.show.count			= true;
							this.show.volumen 		= true;
					}else
						if (action == HIKVISION_PLAY_AUDIO_ACTION) {
							this.show.deviceId = true;
							this.show.speakerSound = true;
							this.show.speakerSoundFile = true;
							this.show.frequency = false;
							this.show.frecuency = false;
							this.info_dev.frequency = 0;
							this.ensure_access_control_sound_options();
						}else
						if (action == "webhook"){
							this.show.destiny 	= true;
						this.show.endpoint 	= true;
						}
				}else if(type == "system"){
						this.show.activeOn = true;
						// Ocultar smart_event cuando la acción es start_counter o empieza con end_
						if (action == 'start_counter' || (action && action.startsWith("end_"))) {
							this.$set(this.show, 'smart_event', false);
							// Mostrar deviceId para seleccionar cámaras cuando es start_counter o end_*
							this.show.deviceId = true;
							console.log('Setting smart_event to false, current value:', this.show.smart_event);
						} else {
							this.$set(this.show, 'smart_event', true);
							// Ocultar deviceId para otras acciones de system
							this.show.deviceId = false;
							console.log('Setting smart_event to true, current value:', this.show.smart_event);
						}
				}
			}else if (key == "deviceId") {
				if (this.info_dev) {
					if (this.info_dev.deviceId) {
							if (this.info_dev.type != ACCESS_CONTROL_ACTION_TYPE && this.info_dev.type != this.info_dev.deviceId.type) {
							this.show.delay 	= false;
							this.show.pin 		= false;
							this.show.value 	= false;
							this.show.seconds 	= false;
							this.show.destiny  	= false;
							this.show.endpoint	= false;
							this.show.actionRing 	= false;
								this.show.file 			= false;
								this.show.count			= false;
								this.show.volumen 		= false;
								this.show.activeOn = true;

						}
						// this.info_dev.type = this.info_dev.deviceId.type;
						this.info_dev.name = this.info_dev.deviceId.name;
						this.show.action = true;
						this.show.activeOn = false;
						this.show.speakerSound = false;
						this.show.speakerSoundFile = false;
						// if (this.info_dev.type && this.list_action_dev_opt[this.info_dev.type]) {
						// 	this.list_action_dev = this.list_action_dev_opt[this.info_dev.type];

						// }else{
						// 	console.warn("No find option select in device ", this.info_dev.type)
						// }
					}
				}
			}
		    }, // render shows

		    render_shows_created(){
			this.fieds_table_dev.forEach((dev)=>{
				this.show[dev.key] = dev.show;
				if (this.info_dev) {
					if (this.info_dev[dev.key]) {
						this.show[dev.key] = true;
					}
				}


			})
		    }, // render_shows_created

		    formatJsonRing(item){
			return this.$Helper.to_string({
				action : item.actionRing,
				file : item.file,
					mode : item.mode,
					count : item.count,
					volumen: item.volumen,

			})
		    },

		    save_dev(){
			if (this.info_dev) {
				if (this.normalize_relay_state_value) this.normalize_relay_state_value();
				if (this.info_dev.action == 'ring') {
					this.info_dev.value = this.formatJsonRing(this.info_dev);
				}
					if (!this.validate_hikvision_payload()) return;
					this.prepare_hikvision_payload();
				if (this.info && this.info.id) {
					let info_up 						 = this.info_dev;
					info_up.Detail_action_device_alarmId = this.info.id;
					info_up.name 					 	 = info_up && info_up.deviceId && info_up.deviceId.name ?  info_up.deviceId.name : info_up.name ;
					info_up.deviceId 					 = info_up && info_up.deviceId && info_up.deviceId.deviceId ?  info_up.deviceId.deviceId : info_up.deviceId ;
					this.loading_dev 					 = true;
					info_up = this.normalizeActionDevicePayload(info_up);
					const api = this.$URL + "/api/v1/alarm/action/device";
					this.$axios.post(api, info_up).then(res => {
						this.loading_dev = false;
						this.dialog_dev  = false;
						res.data.name 	 = info_up.name;
							this.list_dev.push({ ...this.normalizeActionDevicePayload(res.data) });
						this.send_to_alarm();
						this.info_dev 	 = {};
						this.total_dev 	 = this.list_dev.length ;

					}).catch( er => {
						this.loading_dev = false;
						console.log("Error create action device ", er)
					})

				}else{
					console.log("***************************** \n", this.info_dev)

					if (this.info_dev && this.info_dev.deviceId && this.info_dev.deviceId.deviceId) {
						this.info_dev.name 	   = this.info_dev.deviceId.name;
						this.info_dev.deviceId = this.info_dev.deviceId.deviceId;
					}
					this.list_dev.push({ ...this.normalizeActionDevicePayload(this.info_dev) });
					this.total_dev   = this.list_dev.length;
					this.info_dev 	 = {};
					this.dialog_dev  = false;
					this.send_to_alarm();

					// this.$emit("action_device", [ ...this.list_dev ]);
				}

			}
		    }, // save dev

		    update_dev(){
			if (this.info_dev) {
				if (this.normalize_relay_state_value) this.normalize_relay_state_value();
				if (this.info_dev.action == 'ring') {
						this.info_dev.value = this.formatJsonRing(this.info_dev);
					}
					if (!this.validate_hikvision_payload()) return;
					this.prepare_hikvision_payload();
				if (this.info_dev.id) {

					let info_up 	 = this.info_dev;
					info_up.name 	 = info_up && info_up.deviceId && info_up.deviceId.name ?  info_up.deviceId.name : info_up.name ;
					info_up.deviceId = info_up && info_up.deviceId && info_up.deviceId.deviceId ?  info_up.deviceId.deviceId : info_up.deviceId ;

					this.loading_dev = true;

							info_up = this.normalizeActionDevicePayload(info_up);
					const api = this.$URL + "/api/v1/alarm/action/device/" + info_up.id;

					this.$axios.put(api, info_up).then(res => {
						this.loading_dev = false;
						this.dialog_dev  = false;
						this.info_dev.name 	 = info_up && info_up.name ? info_up.name : null;
						// this.list_dev[this.item_info] = { ...this.info_dev };
							this.list_dev.splice(this.item_info, 1, { ...this.normalizeActionDevicePayload(this.info_dev) });
						this.info_dev = {};
						this.send_to_alarm();
						this.info_dev 	 = {};
							this.action_dev  = "save";

					}).catch( er => {
						this.loading_dev = false;
						console.log("Error create action device ", er)
					})
				}else{
					if (this.info_dev && this.info_dev.deviceId && this.info_dev.deviceId.deviceId) {
						this.info_dev.name 		= this.info_dev.deviceId.name;
						this.info_dev.deviceId 	= this.info_dev.deviceId.deviceId;
					}
							this.list_dev.splice(this.item_info, 1, { ...this.normalizeActionDevicePayload(this.info_dev) });
					this.info_dev 	 = {};
					this.dialog_dev  = false;
						this.action_dev  = "save";

					// this.$emit("action_device", [ ...this.list_dev ]);
					this.send_to_alarm();

				}
			}

		    }, // update dev

		    delete_dev(){
			if (this.info_dev) {
				if (this.info_dev.id) {
					let info_up 		= this.info_dev;
					this.loading_dev 	= true;
					const api = this.$URL + "/api/v1/alarm/action/device/" + info_up.id;
					this.$axios.delete(api).then( res => {
						this.loading_dev = false;
						this.list_dev.splice(this.item_info, 1);
						this.info_dev 	 = {};
						this.total_dev 	 = this.list_dev.length ;

						this.send_to_alarm();
					}).catch(er => {
						this.loading_dev = false;
						console.log("error delete action device ", er);
					})
				}else{
					this.list_dev.splice(this.item_info, 1);
					this.total_dev = this.list_dev.length ;
					this.info_dev  = {};
					this.send_to_alarm();

				}

			}
		    }, // delete dev

		    send_to_alarm(){
		     if (Array.isArray(this.list_dev)) {
						this.info.detail_action_device = this.list_dev.map((item) => {
							return this.normalizeActionDevicePayload(item);
						});
		     }else{
						this.info.detail_action_device = this.normalizeActionDevicePayload(this.list_dev);
		     }
		     this.$emit('info_component', {
						act 	: 'render_compt',
						opt 	: 'actions',
						value 	: this.info,
		     });
			this.render_shows('action'); // hide the options

		    }, // send to alarm

		},// methods


		mounted(){
			let temp = 'notifications_modal' + this.ID_notification;
			EventBus.$on(temp, this.bus[temp] =(action) =>{
				if (action) {
					if (this.action_info == "delete_dev") {
						this.delete_dev();
					}else{a
						this.actions('delete');
					}
				}
			})
		}, // mounted

		beforeDestroy(){
			this.$Helper.clear_bus(EventBus, this.bus, "smart_event_actions")
		},
	};
</script>
